/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
// import React from 'react';
// import { Chart, registerables } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';

import {
  Translation, useTranslation
} from 'react-i18next';
// Chart.register(...registerables);
// export default function CardLineChart({ data, page }) {
//   const { t } = useTranslation();
//   let config = {
//     type: "line",
//     data: {
//       labels: data.labels,
//       datasets: [
//         // {
//         //   label: new Date().getFullYear(),
//         //   backgroundColor: "#4c51bf",
//         //   borderColor: "#4c51bf",
//         //   data: [65, 78, 66, 44, 56, 67, 75],
//         //   fill: false,
//         // },
//         {
//           label: t(page),
//           fill: false,
//           backgroundColor: "#fff",
//           borderColor: "#fff",
//           data: data.data,
//         }
//       ],
//     },
//     options: {
//       maintainAspectRatio: false,
//       responsive: true,
//       title: {
//         display: false,
//         text: "Charts",
//         fontColor: "white",
//       },
//       legend: {
//         labels: {
//           fontColor: "white",
//         },
//         align: "end",
//         position: "bottom",
//       },
//       tooltips: {
//         mode: "index",
//         intersect: false,
//       },
//       hover: {
//         mode: "nearest",
//         intersect: true,
//       },
//       scales: {
//         xAxes: [
//           {
//             ticks: {
//               fontColor: "rgba(255,255,255,.7)",
//             },
//             display: false,
//             scaleLabel: {
//               display: false,
//               labelString: "Month",
//               fontColor: "white",
//             },
//             gridLines: {
//               display: false,
//               borderDash: [2],
//               borderDashOffset: [2],
//               color: "rgba(33, 37, 41, 0.3)",
//               zeroLineColor: "rgba(0, 0, 0, 0)",
//               zeroLineBorderDash: [2],
//               zeroLineBorderDashOffset: [2],
//             },
//           },
//         ],
//         yAxes: [
//           {
//             ticks: {
//               fontColor: "rgba(255,255,255,.7)",
//             },
//             display: true,
//             scaleLabel: {
//               display: false,
//               labelString: "Value",
//               fontColor: "white",
//             },
//             gridLines: {
//               borderDash: [3],
//               borderDashOffset: [3],
//               drawBorder: false,
//               color: "rgba(255, 255, 255, 0.15)",
//               zeroLineColor: "rgba(33, 37, 41, 0)",
//               zeroLineBorderDash: [2],
//               zeroLineBorderDashOffset: [2],
//             },
//           },
//         ],
//       },
//     },
//   };
//   let ctx = document.getElementById("line-chart");

//   React.useEffect(() => {

//     window.myLine = new Chart(ctx, config);


//   }, [config, ctx, data]);
//   return (
//     <>
//       <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-800">
//         <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
//           <div className="flex flex-wrap items-center">
//             <Translation>
//               {(t) =>
//                 <div className="relative w-full max-w-full flex-grow flex-1">
//                   <h6 className="uppercase text-gray-200 mb-1 text-xs font-semibold">
//                     {t('overview')}
//                   </h6>
//                   <h2 className="text-white text-xl font-semibold">{t('1-week-trend')}</h2>
//                 </div>
//               }
//             </Translation>
//           </div>
//         </div>
//         <div className="p-4 flex-auto">
//           {/* Chart */}
//           <div className="relative h-350-px">
//             <canvas id="line-chart"></canvas>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
export default function CardLineChart({ data, page }) {
  const { t } = useTranslation();
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: t(page),
        data: data.data,
        fill: false,
        backgroundColor: "#fff",
        borderColor: "#fff",
        borderJoinStyle: "round",
        tension:0.25
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    title: {
      display: false,
      text: "Charts",
      fontColor: "white",
    },
    legend: {
      labels: {
        fontColor: "white",
      },
      align: "end",
      position: "bottom",
    },
    tooltips: {
      mode: "index",
      intersect: false,
    },
    hover: {
      mode: "nearest",
      intersect: true,
    },
    scales: {
      x: {
        ticks: {
          fontColor: "rgba(255,255,255,.7)",
        },
        display: false,
        scaleLabel: {
          display: false,
          labelString: "Month",
          fontColor: "white",
        },
        gridLines: {
          display: false,
          borderDash: [2],
          borderDashOffset: [2],
          color: "rgba(33, 37, 41, 0.3)",
          zeroLineColor: "rgba(0, 0, 0, 0)",
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
        },
      },
      y: [
        {
          ticks: {
            fontColor: "rgba(255,255,255,.7)",
          },
          display: true,
          scaleLabel: {
            display: false,
            labelString: "Value",
            fontColor: "white",
          },
          gridLines: {
            borderDash: [3],
            borderDashOffset: [3],
            drawBorder: false,
            color: "rgba(255, 255, 255, 0.15)",
            zeroLineColor: "rgba(33, 37, 41, 0)",
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
          },
        },
      ],
    },
  };
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-800">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <Translation>
              {(t) =>
                <div className="relative w-full max-w-full flex-grow flex-1">
                  <h6 className="uppercase text-gray-200 mb-1 text-xs font-semibold">
                    {t('overview')}
                  </h6>
                  <h2 className="text-white text-xl font-semibold">{t('1-week-trend')}</h2>
                </div>
              }
            </Translation>
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* Chart */}
          <div className="relative h-350-px">
            <Line data={chartData} options={options} />
          </div>
        </div>
      </div>
    </>
  )
}